import Modal from "src/components/common/modal";
import {
    onlyUnique
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    closeIt,
    setCurrentPage,
    curFilter,
    setFilter,
    defaultFilter, 
    workInstructions
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {"60%"}
        >
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Location:</span>
                <input className = "form-control inline" value = {curFilter.location} onChange = {e => {
                    setFilter({...curFilter, location: e.currentTarget.value.toLocaleLowerCase()});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.location !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, location: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Start Time:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.startTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.startTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, startTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.startTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.startTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, startTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.startTimeMax || curFilter.startTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, startTimeMin: "", startTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">End Time:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.endTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.endTimeMin} 
                    onChange = {e => {
                        setFilter({...curFilter, endTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.endTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.endTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, endTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.endTimeMax || curFilter.endTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, endTimeMin: "", endTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Work Hours:</span>
                <span className = "mr-3">Min:</span>
                <input style = {{maxWidth: "100px"}} 
                step = "any"
                max = {curFilter.workHoursMax}
                value = {curFilter.workHoursMin} onChange = {e => {
                    setFilter({...curFilter, workHoursMin: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                <span className = "mx-3">Max:</span>
                <input style = {{maxWidth: "100px"}}
                step = "any" 
                min = {curFilter.workHoursMin}
                value = {curFilter.workHoursMax} onChange = {e => {
                    setFilter({...curFilter, workHoursMax: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                {
                curFilter.workHoursMax || curFilter.workHoursMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, workHoursMin: "", workHoursMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Travel Hours:</span>
                <span className = "mr-3">Min:</span>
                <input style = {{maxWidth: "100px"}} 
                step = "any"
                max = {curFilter.travelHoursMax}
                value = {curFilter.travelHoursMin} onChange = {e => {
                    setFilter({...curFilter, travelHoursMin: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                <span className = "mx-3">Max:</span>
                <input style = {{maxWidth: "100px"}} 
                step = "any"
                min = {curFilter.travelHoursMin}
                value = {curFilter.travelHoursMax} onChange = {e => {
                    setFilter({...curFilter, travelHoursMax: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                {
                curFilter.travelHoursMax || curFilter.travelHoursMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, travelHoursMin: "", travelHoursMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Total Hours:</span>
                <span className = "mr-3">Min:</span>
                <input style = {{maxWidth: "100px"}} 
                step = "any"
                max = {curFilter.totalHoursMax}
                value = {curFilter.totalHoursMin} onChange = {e => {
                    setFilter({...curFilter, totalHoursMin: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                <span className = "mx-3">Max:</span>
                <input style = {{maxWidth: "100px"}} 
                step = "any"
                min = {curFilter.totalHoursMin}
                value = {curFilter.totalHoursMax} onChange = {e => {
                    setFilter({...curFilter, totalHoursMax: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" className = "form-control inline mr-1"/>
                {
                curFilter.totalHoursMax || curFilter.totalHoursMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, totalHoursMin: "", totalHoursMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Billed:</span>
                <select className = "form-control inline" value = {curFilter.billed} onChange = {e => {
                    setFilter({...curFilter, billed: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>No</option>
                    <option>Yes</option>
                </select>
                {
                curFilter.billed !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, billed: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Description:</span>
                <input className = "form-control inline" value = {curFilter.workInstructionDescription} onChange = {e => {
                    setFilter({...curFilter, workInstructionDescription: e.currentTarget.value.toLocaleLowerCase()});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.workInstructionDescription !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, workInstructionDescription: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Supervisor:</span>
                <select className = "form-control inline" value = {curFilter.supervisor} onChange = {e => {
                    setFilter({...curFilter, supervisor: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>No</option>
                    {workInstructions.map(f => f.supervisor).filter(onlyUnique).map((f, fi) => <option key = {fi}>{f}</option>)}
                </select>
                {
                curFilter.supervisor !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, supervisor: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Creator:</span>
                <select className = "form-control inline" value = {curFilter.creator} onChange = {e => {
                    setFilter({...curFilter, creator: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {workInstructions.map(u => u.creator).filter(onlyUnique).map((u, ui) => <option key = {ui}>{u}</option>)}
                </select>
                {
                curFilter.creator !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, creator: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Date Created:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.createdMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.createdMin}
                    onChange = {e => {
                        setFilter({...curFilter, createdMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.createdMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.createdMax}
                    onChange = {e => {
                        setFilter({...curFilter, createdMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.createdMax || curFilter.createdMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, createdMin: "", createdMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Updater:</span>
                <select className = "form-control inline" value = {curFilter.updater} onChange = {e => {
                    setFilter({...curFilter, updater: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {workInstructions.map(u => u.updater).filter(onlyUnique).map((u, ui) => <option key = {ui}>{u}</option>)}
                </select>
                {
                curFilter.updater !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updater: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Date Updated:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.updatedMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.updatedMin}
                    onChange = {e => {
                        setFilter({...curFilter, updatedMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.updatedMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.updatedMax}
                    onChange = {e => {
                        setFilter({...curFilter, updatedMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.updatedMax || curFilter.updatedMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updatedMin: "", updatedMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-3 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}